import { isEmpty } from 'lodash';
import memoizeOne from 'memoize-one';

import { DetailProductModel, ProductModel, SubPoint } from '../models/products.model';
import { Position } from '../ui/components/shared/mapContainer';

export const getPaths = (location: ProductModel | DetailProductModel, areaData = true) => {
    const { area = [], subpoints = [] } = location;
    const data: number[][] = areaData ? area : subpoints.map(item => [(item as SubPoint).x, (item as SubPoint).y]);
    const sub_res: Position[] = [];
    const res: Position[][] = [];

    if (!isEmpty(data)) {
        const returnCordsObj = ([lng, lat]: number[]): Position => ({ lat, lng });

        const setCords = (item: number[] | number[][], i: number) => {
            if (Array.isArray(item[0])) {
                res[i] = [] as Position[];
                (item as number[][]).forEach((item: number[]) => res[i].push(returnCordsObj(item)));
            } else {
                sub_res.push(returnCordsObj(item as number[]));
            }
        };

        data.forEach((item: number[], i) => setCords(item, i));
    }

    return isEmpty(res) ? sub_res : res;
};

export const memoizedGetPaths = memoizeOne(getPaths);
